export const editContact = (id) => ({
    type: 'editContact',
    id
})